import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Webnotes from './containers/Webnotes';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducer from './reducers';

const middleware = [ thunk ]

if (process.env.NODE_ENV !== 'production') {
	middleware.push(createLogger());
}

const store = createStore(
	reducer,
	{
		...window.MC_Webnotes_Data.initialState,
		annotationStatus: 'inactive',
		currentComponentTarget: null,
		eventListeners: {
			mouseover: null,
			mouseoout: null,
			click: null
		},
		mousePosition: {
			left: 0,
			top: 0
		}
	},
	applyMiddleware(...middleware)
)

var container = document.createElement('div');
container = document.body.appendChild(container);
ReactDOM.render(
	(
		<Provider store={store}>
			<Webnotes />
		</Provider>
	),
	container
);
/*
(function($, domtoimage, objectL10n) {
	$(function() {
		var app = {
            annotationMode: true,
            $currentElement: {},
			setup: function() {
                $(document).on('click', '.webnotes_notetool-close', app.noteTool.close);
                $(document).on('click', '.webnotes_notetool-savenote', app.note.save);
                $(document).on('click', '.webnotes_note-delete', app.note.remove);
                $(document).on('change', '#webnotes_toggle_annotation_mode', function() {
                    app.setAnnotationMode($(this).is(':checked'));
                });
                $(document.body).append('<div class="webnotes_bar"><a href="/wp-admin/edit.php?post_type=webnotes">' + app.h.t().viewAllSiteNotes + '</a> <input type="checkbox" id="webnotes_toggle_annotation_mode" checked> <label for="webnotes_toggle_annotation_mode">' + app.h.t().turnOnClickAndWriteNote + '</label><div class="webnotes_bar-author"></div></div><div class="webnotes_notetool"><button class="webnotes_notetool-close">X</button><input type="text" placeholder="' + app.h.t().noteTitle + '" data-property="title"><br><textarea placeholder="' + app.h.t().noteText + '" data-property="text"></textarea><button class="webnotes_notetool-savenote">' + app.h.t().saveNote + '</button><div class="webnotes_notetool-error"></div></div>');
                app.notes.get();
                app.setAnnotationMode(app.annotationMode);
                console.log(app.h.t().annotationReady);
			},
            setAnnotationMode: function(flag) {
                if (flag) {
                    $(document).on('mouseenter', 'article, footer, header', app.components.enter)
                        .on('mouseleave', 'article, footer, header', app.components.leave)
                        .on('click', app.noteTool.show);
                } else {
                    $(document).off('mouseenter', 'article, footer, header', app.components.enter)
                        .off('mouseleave', 'article, footer, header', app.components.leave)
                        .off('click', app.noteTool.show);
                }
                app.annotationMode = flag;
			},
			h: {
				t: function(key) {
                    return key ? objectL10n[key] : objectL10n;
				}
			},
            components: {
                enter: function() {
                    $(this).css({ outline: '4px dotted red' });
				},
                leave: function() {
                    $(this).css({ outline: 'none' });
				}
            },
			notes: {
                get: function() {
					$('.webnotes_bar').addClass('webnotes_waiting');
					$.post('/wp-admin/admin-ajax.php',
						{
							action: 'webnotes_getnotes',
							url: window.location.href
						}, 'json')
						.done(function(data) {
							var JSONdata = {};
							try {
								JSONdata = JSON.parse(data);
							} catch (e) {
								console.log('Wrong JSON format: ' + e);
							}
							$('.webnotes_bar').attr('data-author', JSONdata.author);
							$('.webnotes_bar-author').html(app.h.t().annotator + ': ' + JSONdata.author);
							for (var i = 0, n = JSONdata.notes.length; i < n; i++) {
								app.note.show(JSONdata.notes[i]);
							}
							$('.webnotes_bar').removeClass('webnotes_waiting');
						})
						.fail(function(jqxhr, textStatus, error) {
							console.log('Could not get notes: ' + textStatus + ', ' + error);
						});
				}
			},
			note: {
            	show: function(note) {
                    var noteAuthor = note.author === $('.webnotes_bar').attr('data-author') ? 'you' : note.author,
                        $newNote = $('<div class="webnotes_note" data-note_id="' + note.note_id + '" data-note_viewport_width="' + note.context.viewport_width + '"><button class="webnotes_note-delete">X</button><p><strong>' + note.title + '</strong></p><p>' + note.text + '</p><p>' + app.h.t().author + ': ' + noteAuthor + '</p><div class="webnotes_note-error"></div></div>');
                    $(document.body).append($newNote.css({ left: +note.context.left, top: +note.context.top }));
                },
				save: function() {
                    var $noteTool = $(this).closest('.webnotes_notetool'),
                        note = {
                            url: window.location.href,
                            title: $noteTool.find('[data-property="title"]').val(),
                            text: $noteTool.find('[data-property="text"]').val(),
                            context: {
                                left: $noteTool.position().left,
                                top: $noteTool.position().top,
                                user_agent:  window.navigator.userAgent,
                                viewport_width: $(window).width(),
                                viewport_height: $(window).height()
                            }
                        };
                    $noteTool.addClass('webnotes_waiting');
                    domtoimage.toPng(app.$currentElement.get(0))
                        .then(function (dataUrl) {
                            note.context.image = dataUrl;
                            $.post('/wp-admin/admin-ajax.php',
                                {
                                    action: 'webnotes_savenote',
                                    note: note
                                })
                                .done(function(data) {
                                    $noteTool.removeClass('webnotes_waiting');
                                    note.note_id = data;
                                    note.author = 'you';
                                    app.note.show(note);
                                    app.noteTool.close();
                                })
                                .fail(function(jqxhr, textStatus, error) {
                                    $noteTool.removeClass('webnotes_waiting');
                                    $('.webnotes_notetool-error').html('Could not save note: ' + textStatus + ", " + error);
                                });

                        })
                        .catch(function (err) {
                            $noteTool.removeClass('webnotes_waiting');
                            $('.webnotes_notetool-error').html('Could not create page thumbnail: ' + err);
                        });

                },
				remove: function() {
                    var $note = $(this).closest('.webnotes_note');
                    $note.addClass('webnotes_waiting');
                    $.post('/wp-admin/admin-ajax.php',
                        {
                            action: 'webnotes_deletenote',
                            note_id: $note.attr('data-note_id')
                        })
                        .done(function(data) {
                            $note.remove();
                        })
                        .fail(function(jqxhr, textStatus, error) {
                            $note.removeClass('webnotes_waiting');
                            $('.webnotes_note-error').html('Could not delete note: ' + textStatus + ", " + error);
                        });
				}
			},
			noteTool: {
            	show: function(e) {
                    if ($(e.target).closest('.webnotes_bar, .webnotes_notetool, .webnotes_note').length === 0) {
                        $(document).off('click', app.noteTool.show);
                        $('.webnotes_notetool [data-property]').val('');
                        $('.webnotes_notetool').css({ left: e.pageX, top: e.pageY }).addClass('webnotes_notetool-show');
                        app.$currentElement = $(e.target);
                    }
				},
				close: function() {
                    $(document).on('click', app.noteTool.show);
                    $('.webnotes_notetool').removeClass('webnotes_notetool-show');
                }

			}
		};
		app.setup();
	});
})(jQuery, domtoimage, objectL10n);
    */


// WEBPACK FOOTER //
// ./src/js/mc-webnotes.js